import React from 'react';

import { StudentWidgetWrapper } from 'src/application/ContentZone/components/Widgets/StudentWidgetWrapper';
import { useIsMobileV2 } from 'src/application/hooks/useIsMobile';

import { useContentBlocksContext } from '../../ContentBlocksContext';
import { useGetSingleImageAssetData } from '../../hooks/useGetMultipleAssetUrls';
import { ExistingStudentWidgetProps } from '../Widget';
import { TextOnImageWidget as TextOnImageWidgetModel } from '@ael/core-api';
import { TextOnImageWidget as TextOnImageWidgetComponent } from '@ael/shared-components-library';
import classNames from 'classnames';

import './TextOnImageWidget.scss';

export const TextOnImageWidget = (props: ExistingStudentWidgetProps) => {
  const textOnImageWidget = props.widget as TextOnImageWidgetModel;
  const properties = textOnImageWidget.value.properties;
  const asset = useGetSingleImageAssetData(
    textOnImageWidget._id,
    textOnImageWidget.value.type,
    textOnImageWidget.value.data.assetId
  );

  const isMobile = useIsMobileV2();
  const { inSmallWindow } = useContentBlocksContext();

  const isSmallContainer = isMobile || inSmallWindow;

  return (
    <StudentWidgetWrapper>
      {props.widget.initialized && (
        <TextOnImageWidgetComponent
          imageUrl={asset?.url ?? ''}
          text={
            <div
              className={classNames('text-on-image-widget__text', {
                'uno-max-w-full': isSmallContainer,
                'uno-max-w-60%': !isSmallContainer,
              })}
              dangerouslySetInnerHTML={{ __html: textOnImageWidget.value.data.title }}
            />
          }
          overlayColor={properties.overlayColor}
          overlayOpacity={properties.overlayOpacity}
        />
      )}
    </StudentWidgetWrapper>
  );
};
